/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';
import {
  RadialBarChart,
  RadialBar,
  Legend,
  ResponsiveContainer,
  PolarAngleAxis
  // Tooltip,
} from 'recharts';

import {sortBy} from '../../../shared/commonFunctions';
import Loader from '../../Loader/Loader';
import sumTableValue from '../../Table/Utils/sumTableValue';

import {RadialChartStyle} from './constants/common';
import RadialChartProps from './interfaces/RadialChartProps';
// import RadialCustomizedLabel from './utils/RadialCustomizedLabel';
import RadialCustomizedLegend from './utils/RadialCustomizedLegend';

const RadialChart: React.FC<{data: RadialChartProps[]}> = ({data}) => {
  const [mainData, setMainData] = useState<any[]>([]);

  useEffect(() => {
    setMainData(sortBy(data, 'value', 'asc'));
  }, [data]);

  const total = sumTableValue(mainData, 'value', false);

  return mainData.length === 0 ? (
    <Loader />
  ) : (
    <ResponsiveContainer width="100%" aspect={1} className="radialBarChart">
      <RadialBarChart
        cx="25%"
        outerRadius={'100%'}
        innerRadius={'10%'}
        barSize={24}
        data={mainData}
        startAngle={450}
        endAngle={90}
      >
        <PolarAngleAxis type="number" domain={[0, total]} tick={false} />
        <RadialBar
          background
          dataKey="value"
          // strokeLinecap="round"
          // strokeLinejoin="round"
          // label={(props) => <RadialCustomizedLabel {...props} total={total} />}
          label={{
            position: 'end',
            offset: 2,
            style: {fill: '#677489', font: 'normal normal 600 28px Montserrat'},
            formatter: (value: any) => {
              const totalValue = value / Number(total);
              const percent = totalValue * 100;

              return percent <= 0 || isNaN(percent)
                ? ''
                : `${Math.round(percent)} %`;
            }
          }}
          cornerRadius="50%"
          angleAxisId={0}
        />
        <Legend
          iconSize={7}
          layout="vertical"
          verticalAlign="middle"
          wrapperStyle={RadialChartStyle}
          iconType="circle"
          content={<RadialCustomizedLegend data={mainData} />}
        />
        {/* <Tooltip
          // separator=':'
          cursor={false}
          wrapperStyle={{
            backgroundColor: 'red',
            borderRadius: '25px'
          }}
          filterNull
          itemStyle={{
            borderRadius: '25px !important'
          }}
          formatter={(value: number) => {
            return [
              `${Math.round((value / Number(total)) * 100)} %`,
              'Percent'
            ];
          }}
          labelFormatter={(_, name: any) => {
            return `${name?.[0]?.payload?.name || ''}`;
          }}
        /> */}
      </RadialBarChart>
    </ResponsiveContainer>
  );
};

export default RadialChart;
